import { AuthDrawerEnum } from "~/types/components.types";
export default defineNuxtRouteMiddleware((_, from) => {
  const generalStore = useGeneralStore();
  const localePath = useLocalePathPolyfill();
  if (!generalStore.isAuthenticated) {
    return navigateTo(
      localePath({
        path: "/",
        query: {
          drawer: AuthDrawerEnum.LOGIN,
          redirect: localePath(from),
        },
      }),
    );
  }
});
